exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 768px) {\n#feedback[data-v-c420f36c],\n  #help[data-v-c420f36c] {\n    display: none;\n}\n}\n.nh5[data-v-c420f36c] {\n  margin-left: -4rem;\n  margin-right: -4rem;\n}\n.mw-img[data-v-c420f36c] {\n  max-width: 119px;\n  height: 25px;\n}\n\n/* Mobile Devices */\n@media screen and (max-width: 600px) {\n.mobile-hide[data-v-c420f36c] {\n    display: none;\n}\n}\n", ""]);

// exports
